const architecturePage = {
  diagramTitle: "Architecture Diagram",
  toolStackTitle: "Tool Stack",
  layerUI: "UI",
  layerDB: "Database",
  layerSOT: "Operational SOT",
  layerKnowledge: "Knowledge SOT",
  layerAutomation: "Automation",
  layerMessaging: "Messaging",
  colTool: "Tool",
  colLayer: "Layer",
  colRole: "Role",
  colDoesNot: "Does NOT",
  readOnly: "Read-only",
  dataFromClaudeMd: "Based on CLAUDE.md",
} as const;
export default architecturePage;
